import React from "react";
import { Link } from "react-router-dom";
import "../../styles/components/landingPage/Footer.css";

const Footer: React.FC = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="footer">
      <div className="footer-content">
        <div className="footer-links">
          <Link to="/impressum" aria-label="Impressum">Impressum</Link>
          <Link to="/agb" aria-label="Allgemeine Geschäftsbedingungen">AGB</Link>
          <Link to="/privacy-policy" aria-label="Datenschutzerklärung">Datenschutzerklärung</Link>
        </div>
        <div className="footer-text">
          © {currentYear} Mundwerte - Alle Rechte vorbehalten
        </div>
      </div>
    </footer>
  );
};

export default Footer;
